import InternalAPI from "../../../../../app/axios.js"
import "../types"

/** @borrows InternalAPI */
export default class FAQRepository extends InternalAPI {
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v2/faq/admin"
    }

    /**
     *
     * @param reqData {RequestFAQ}
     * @return {Promise<{err: null, message: string}|{err: string, message: string}|{err: *, message: null}>}
     */
    async createOne(reqData) {
        try {
            /** @type {AxiosResponse<Object>}*/
            const res = await this.$axios.post(this.endpoint, reqData)
            const msg = res.data.data.message || ""
            if (res.status === 201) {
                return {message: msg, err: null}
            }
            return {message: msg, err: "something went wrong"}
        } catch (err) {
            return {message: null, err: this.setErrorMessage(err.response)}
        }
    }

    /**
     *
     * @param id {number}
     * @return {Promise<{data: FAQ, err: null}|{data: null, err: string}|{data: null, err: *}>}
     */
    async getOneByID(id) {
        try {
            const res = await this.$axios.get(this.endpoint + "/" + id)
            if (res.status === 200) {
                return {data: res.data.data, err: null}
            }
            return {data: null, err: "something went wrong"}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }

    /**
     *
     * @param id {number}
     * @param reqData {RequestFAQ}
     * @return {Promise<{err: null, message: string}|{err: string, message: string}|{err: *, message: null}>}
     */
    async updateOneByID(id, reqData) {
        try {
            const res = await this.$axios.put(this.endpoint + "/" + id, reqData)
            const msg = res.data.data.message || ""
            if (res.status === 201) {
                return {message: msg, err: null}
            }
            return {message: "", err: "something went wrong"}
        } catch (err) {
            return {message: null, err: this.setErrorMessage(err.response)}
        }
    }

    /**
     *
     * @param queries
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        try {
            const res = await this.$axios.get(this.endpoint + "/data" + queries)
            if (res.status === 200) {
                return {data: res.data.data.data, err: null}
            }
            return {data: [], err: "something went wrong"}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }
}
